import React, {useContext, useRef, useState} from "react";
import PagedSearchTable, {PagedTableFunctions} from "../components/PagedSearchTable";
import WarningPopup, {useWarningState} from "../components/WarningPopup";
import AppContext from "../appContext";
import Originate from "../controllers/Originate";
import DepotController from "../controllers/DepotController";
import Depot from "../controllers/Depot";
import {useValidation} from "../validation";
import {showSuccessOrFailed} from "../Snacks";
import {useStateSetter} from "../immutableState";
import Dialog from "../components/Dialog";
import {EditRow, EditTable} from "../components/Fields";
import Input from "../components/Input";
import {wrapLoader} from "../wrapper";
import SelectNumberNullable from "../components/SelectNumberNullable";

const emptyDepot: Depot = {
    id: 0,
    name: '',
    archived: false,
    originate: Originate.International
}

const ManageDepots: React.FC = (props) => {
    const pagedTableRef = useRef<PagedTableFunctions<Depot>>()
    const context = useContext(AppContext)
    const [assignDepot, setAssignDepot] = useState<Depot | null>(null)
    const [depots, setDepots] = useState<Depot[]>()
    const [newDepotId, setNewDepotId] = useState<number | null>(null)



    const [popupModal, setPopupModal] = useState<boolean>(false)
    const [data, setData, updateData] = useStateSetter<Depot>(emptyDepot)

    const validation = useValidation({
        name: () => data.name != null && data.name.length > 0
    });
    
    const validationDelete = useValidation({
        reassigned: () => newDepotId !== null
    })
    function deleteDepot(){
        if (!validationDelete.validate() || assignDepot == null || newDepotId == null) return;

        showSuccessOrFailed(context, DepotController.archive({id: assignDepot.id, assignId: newDepotId})).then(() => {
            cancelDepotAssign()
            pagedTableRef.current?.refresh();
        })
    }

    function newDepot() {
        setData(emptyDepot)
        setPopupModal(true)
    }

    function editDepot(depot: Depot) {
        setData(depot)
        setPopupModal(true)
    }

    function upsert() {
        if (!validation.validate()) return;

        showSuccessOrFailed(context, DepotController.upsert({id: data.id, name: data.name ?? ""}))
            .then(() => {
                pagedTableRef.current?.refresh();
                setPopupModal(false);
            })
    }
    function cancelDepotAssign() {
        setAssignDepot(null)
        setNewDepotId(null)
    }

    function depotAssign(depot: Depot) {
        wrapLoader(context, DepotController.index(), resp => {
            setDepots(resp)
            setAssignDepot(depot)
        })
    }
    return <div>
        <div className="pb-2">
            <div className="btn bg-primary" onClick={newDepot}>Add Depot</div>
        </div>
        <PagedSearchTable componentRef={pagedTableRef}
                          call={DepotController.paged}
                          columns={[
                              {
                                  header: 'Depot',
                                  key: 'depot',
                                  row: (row) => row.name
                              },
                              {
                                  header: <div className='text-right'>Actions</div>,
                                  key: 'actions',
                                  row: (row, index) => <div className='text-right'>
                                      <div className="bg-primary btn-sm"
                                           onClick={() => editDepot(row)}>
                                          edit
                                      </div>
                                      <div className="bg-red-500 btn-sm"
                                           onClick={() => depotAssign(row)}>x
                                      </div>
                                  </div>
                              }
                          ]}/>

        <Dialog title={"Depot"}
                show={popupModal}
                setShow={setPopupModal}
                body={<>
                    <EditTable discard={() => setPopupModal(false)} save={() => upsert()}
                               saveWord={data.id === 0 ? 'insert' : 'update'}>
                        {EditRow('Name', <Input value={data.name ?? ''}
                                                change={v => updateData({name: v})}/>, validation.rules.name, 'Name required')}
                    </EditTable>
                </>}/>

        <Dialog title={`Assign ${assignDepot?.name ? assignDepot.name : "this depot"} to New Depot`}
                show={assignDepot != null}
                setShow={cancelDepotAssign}
                body={<div>
                    <EditTable discard={() => cancelDepotAssign()}
                               save={() => deleteDepot()}
                               saveWord={'ReAssign'}>
                        {depots !== null && depots ? EditRow('Depot', <div className='text-right'>
                                <SelectNumberNullable options={depots.filter(a => a.id !== assignDepot?.id)}
                                                      textFunc={t => t.name ?? ""}
                                                      valueFunc={v => v.id}
                                                      value={newDepotId}
                                                      onChange={v => setNewDepotId(v)}/>
                            </div>,
                            validationDelete.rules.reassigned,
                            'Select a depot to reassign'
                        ) : null}
                    </EditTable>
                </div>}/>
    </div>
}

export default ManageDepots;